import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\orion-nextjs\\orion-nextjs\\node_modules\\react-bootstrap\\esm\\Col.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\orion-nextjs\\orion-nextjs\\node_modules\\react-bootstrap\\esm\\Container.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\orion-nextjs\\orion-nextjs\\node_modules\\react-bootstrap\\esm\\Row.js");
